export const news = [
  {
    id: 'n1',
    title: '《春夜迷情》口碑持续走高，被赞年度最细腻的情感悬疑',
    summary: '上映三周，《春夜迷情》凭借克制的叙事与精准的氛围营造，成为近期讨论度最高的情感悬疑片之一。',
    tag: '影评',
    date: '2026-10-08',
    author: '编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20warm%20crimson%20neon%20reflections%20on%20wet%20asphalt%2C%20cinematic%20moody%20atmosphere%2C%20deep%20red%20and%20charcoal%20color%20grade%2C%20editorial%20film%20photography&width=800&height=500&seq=jq-news-01&orientation=landscape',
    content: [
      '自上映以来，《春夜迷情》的讨论热度持续攀升。影片并没有把重心放在戏剧化的冲突上，而是用大量的雨夜、街灯与沉默特写，去描摹两个成年人之间那种既克制又无法忽视的吸引力。',
      '有影评人指出，影片最难得的地方在于它对人物处境的体谅。它不急于评判，而是让观众在共情与不安之间反复摇摆，这种复杂的情感体验正是该类型作品最珍贵的部分。',
      '主演金敏书的表演也被反复提及。她在片中几乎没有夸张的肢体动作，仅凭眼神与停顿，便完成了角色从隐忍到动摇的全部心理层次。',
      '据悉，片方已确认将推出导演特别版，补充部分被删减的支线内容。对于喜爱细腻情感叙事的观众来说，这无疑是一个值得期待的消息。',
    ],
  },
  {
    id: 'n2',
    title: '电视剧《婚戒背后》定档，聚焦都市婚姻的隐秘角落',
    summary: '这部以三段婚姻为主线的都市情感剧正式定档，将于本月下旬与观众见面。',
    tag: '资讯',
    date: '2026-10-05',
    author: '剧集观察',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20city%20night%20skyline%20with%20glass%20office%20towers%20and%20scattered%20warm%20window%20lights%2C%20deep%20red%20and%20charcoal%20cinematic%20color%20grade%2C%20urban%20melodrama%20atmosphere&width=800&height=500&seq=jq-news-02&orientation=landscape',
    content: [
      '由李慕白执导的都市情感剧《婚戒背后》正式宣布定档。剧集以金牌律师苏晴的视角展开，透过一桩离婚案，牵连出三个女人各自破碎又互相映照的婚姻。',
      '与同类题材不同，该剧把更多笔墨放在人物的职业与生活细节上。剧方表示，希望观众看到的不是一个简单的“谁对谁错”的故事，而是婚姻中那些被长期忽视的情感空位。',
      '主演苏晴在采访中透露，为了贴近角色，她特意旁听了多场真实的调解现场。“很多真实的对话没有台词那么漂亮，但那种疲惫感特别有力量。”',
    ],
  },
  {
    id: 'n3',
    title: '从《危险关系》看经典情感题材的当代改编',
    summary: '经典文本如何被一次次重新讲述？改编作品在保留情感内核的同时，也在回应新的时代语境。',
    tag: '深度',
    date: '2026-09-30',
    author: '特约撰稿',
    cover:
      'https://readdy.ai/api/search-image?query=Opulent%20candlelit%20ballroom%20with%20chandeliers%20and%20deep%20red%20velvet%20drapes%2C%20blurred%20elegant%20dancing%20figures%2C%20warm%20golden%20and%20crimson%20tones%2C%20period%20cinematic%20atmosphere&width=800&height=500&seq=jq-news-03&orientation=landscape',
    content: [
      '《危险关系》所代表的经典情感文本，几乎每隔十年就会被重新搬上银幕。它们之所以经久不衰，是因为其核心命题——欲望、权力的博弈与人性的复杂——从未真正过时。',
      '当代改编的意义，往往不在于复刻情节，而在于重新回答那些老问题：在一段以征服开始的关系里，真心是否还有可能存在？当两个人都精于算计，谁先动心，谁就先输。',
      '值得注意的是，近年来的改编作品越来越倾向于给女性角色更多主体性。她们不再只是被争夺的对象，而是游戏规则的参与者，甚至制定者。这种视角的转变，也让作品获得了更广泛的共鸣。',
    ],
  },
  {
    id: 'n4',
    title: '《双重生活》第二季制作确认，悬念将在新一季揭晓',
    summary: '凭借紧凑的叙事与出色的表演，这部心理悬疑剧迎来第二季续订。',
    tag: '资讯',
    date: '2026-09-26',
    author: '环球剧讯',
    cover:
      'https://readdy.ai/api/search-image?query=Split%20composition%20of%20two%20different%20cities%20at%20night%20under%20the%20same%20stormy%20sky%2C%20cold%20grey%20and%20deep%20red%20duotone%20grade%2C%20moody%20psychological%20thriller%20cinematic%20shot&width=800&height=500&seq=jq-news-04&orientation=landscape',
    content: [
      '心理悬疑剧《双重生活》确认续订第二季。第一季结尾那个没有给出答案的镜头，让无数观众意难平，也为主角的命运留下了巨大的想象空间。',
      '制作方表示，第二季将把叙事重心从“谎言如何维系”转向“真相揭开之后”，深入探讨身份认同与亲密关系中的信任崩塌。',
      '主演阵容基本确认原班回归，新加入的角色据说会彻底打乱主角原本就已经摇摇欲坠的平衡，可以期待一下。',
    ],
  },
  {
    id: 'n5',
    title: '为什么观众始终为“危险关系”题材着迷？',
    summary: '越界的诱惑、道德的拉扯、无法言说的孤独……这类题材究竟触动了观众怎样的心理？',
    tag: '深度',
    date: '2026-09-20',
    author: '文化评论',
    cover:
      'https://readdy.ai/api/search-image?query=Dim%20narrow%20hallway%20with%20a%20single%20door%20ajar%20casting%20warm%20light%2C%20deep%20shadows%20and%20muted%20crimson%20tones%2C%20tense%20suspense%20cinematic%20atmosphere&width=800&height=500&seq=jq-news-05&orientation=landscape',
    content: [
      '从文学到电影，越界的情感关系始终是最经久不衰的母题之一。它之所以吸引人，很大程度上是因为它把每个人内心深处那种“想要又不敢”的张力具象化了。',
      '这类故事的魅力，不在于鼓励越界，而在于它提供了一面镜子。观众在安全的距离外，得以审视欲望、责任与自我之间的冲突，并在人物的选择中反观自身。',
      '当然，优秀的作品从不简单地美化背叛。它们更愿意呈现代价、呈现悔意，也呈现那些身处其中的人难以言说的孤独。正是这种复杂性，让题材拥有了超越猎奇的价值。',
    ],
  },
  {
    id: 'n6',
    title: '《出轨时代》大结局引热议，开放式结尾褒贬不一',
    summary: '剧集大结局播出后，开放式处理方式在观众中引发了截然不同的讨论。',
    tag: '影评',
    date: '2026-09-15',
    author: '编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20modern%20TV%20studio%20with%20spotlights%20and%20a%20single%20stool%20on%20stage%2C%20deep%20red%20and%20charcoal%20color%20grade%2C%20tense%20atmospheric%20cinematic%20shot&width=800&height=500&seq=jq-news-06&orientation=landscape',
    content: [
      '《出轨时代》播出大结局后，关于结尾的讨论迅速占据了社交平台。剧集并没有给出一个明确的“和解”或“决裂”，而是把选择留给了角色，也留给了观众。',
      '支持的观众认为，这种处理尊重了人物的复杂性，符合整部剧一贯的克制基调；也有观众坦言，追了十几集后，希望能得到一个更明确的答案。',
      '无论如何，这场讨论本身恰恰说明，剧集成功地让观众投入了对人物的情感。或许对于这类题材而言，没有标准答案，才是它最真实的地方。',
    ],
  },
  {
    id: 'n7',
    title: '秋季片单前瞻：值得关注的情感题材新作',
    summary: '多部情感题材电影与剧集将在秋季陆续上线，这份片单帮你提前锁定目标。',
    tag: '资讯',
    date: '2026-09-10',
    author: '片单推荐',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20autumn%20scene%20with%20warm%20low%20sunlight%20through%20dry%20leaves%2C%20moody%20amber%20and%20deep%20red%20tones%20with%20soft%20shadows%2C%20atmospheric%20film%20photography&width=800&height=500&seq=jq-news-07&orientation=landscape',
    content: [
      '随着秋季到来，一批情感题材新作即将陆续与观众见面。从悬疑犯罪到文艺小品，题材覆盖相当广泛，类型爱好者的选择十分丰富。',
      '其中既有聚焦都市婚姻的新剧，也有把背景放在海边小镇的文艺电影。整体来看，这一季的作品更偏好细腻的人物刻画，而非强情节的戏剧冲突。',
      '我们整理了这份片单，按照上映时间排序，并附上了每部作品的看点提示，方便你按自己的口味安排观影计划。',
    ],
  },
  {
    id: 'n8',
    title: '《隔壁的女人》导演谈创作：悬疑只是外壳，孤独才是内核',
    summary: '在一次访谈中，导演分享了这部作品背后关于城市孤独感的思考。',
    tag: '访谈',
    date: '2026-09-02',
    author: '特约撰稿',
    cover:
      'https://readdy.ai/api/search-image?query=Dim%20apartment%20building%20hallway%20with%20warm%20doorway%20light%20and%20deep%20shadows%2C%20muted%20crimson%20accents%2C%20unsettling%20cinematic%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=jq-news-08&orientation=landscape',
    content: [
      '“我一开始想拍的其实不是悬疑片。”导演在访谈中坦言，《隔壁的女人》真正的灵感，来自他在大城市里那种“住得那么近，却谁也不认识谁”的切身感受。',
      '在他的构想里，悬疑只是把观众留在座位上的钩子，而真正想讲的，是现代都市里人与人之间那种既渴望靠近、又本能设防的微妙距离。',
      '这种创作取向，也解释了影片为何在情节之外花了大量篇幅去刻画走廊、门缝与犹豫的脚步声——那些细节，恰恰是孤独最具体的形状。',
    ],
  },
];